import { FC } from 'react';
import Lottie from 'lottie-react';
import animationData from '../../../../_mexablock/assets/json/animation_llqt91u7.json';

const Error401: FC = () => {
  return (
    <>
      <h1 className="fw-bolder fs-4x text-gray-700 mb-10">No autorizado</h1>
      <div className="fw-bold fs-3 text-gray-400">
        ¡No tienes acceso a este recurso!
      </div>
      <div className="d-flex align-items-center flex-column flex-column-fluid text-center">
        <div className="w-400px">
          <Lottie animationData={animationData} />
        </div>
      </div>
    </>
  );
};

export { Error401 };
